import React, { useState, useEffect } from 'react';
import { Row, Col, InputGroup, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';
import y from 'y4/Utils';
import FilterItem from './FilterItem';
import { useTranslation } from 'react-i18next';
import LoadingButton from 'y4/components/common/LoadingButton';

/**
 *
 * At grid top, the FilterPanel component is used to display filter options.
 * FilterPanel component renders a panel with filter items.
 * It allows users to filter data based on various criteria.
 *
 * @param {*}
 * @returns
 */
const FilterPanel = ({ cacheId, panel, filters, values, search }) => {
  const { t } = useTranslation('filter');

  //Read saved filter values from session
  let last_values = values;
  const values_json = y.getSessionItem(`${cacheId}_fp`);
  if (values_json) {
    last_values = JSON.parse(values_json);
    for (const p in last_values) {
      const v = last_values[p];
      if (y.isArray(v)) {
        last_values[p] = v[0];
      }
    }
  } else {
    //Save first values to session
    if (cacheId) y.setSessionItem(`${cacheId}_fp`, JSON.stringify(last_values));
  }

  const [filterValues, setFilterValues] = useState(last_values);

  //After filter input value changed:save to session and update filterValues
  const changed = vs => {
    const new_vs = { ...filterValues, ...vs };

    //delete previous _api value
    const ks = _.keys(vs);
    if (ks.length == 1) {
      delete new_vs[ks[0] + '_api'];
    }

    if (cacheId) y.setSessionItem(`${cacheId}_fp`, JSON.stringify(new_vs));
    setFilterValues(new_vs);
  };

  //Call search
  const searchClick = () => {
    if (search) return search(filterValues);
  };

  //Reset all filter's values to first values
  const resetClick = () => {
    const dfvs = _.get(panel, 'option.defaultFilters', {});
    if (cacheId) y.setSessionItem(`${cacheId}_fp`, JSON.stringify(dfvs));
    setFilterValues(dfvs);
  };

  //Union filters and values
  const [filtersWithValues, setFiltersWithValues] = useState();
  //After values changed refresh filtersWithValues
  useEffect(() => {
    const fwvs = filters.map(ft => {
      const values = _.pickBy(filterValues, (_v, key) => {
        return _.startsWith(key, ft.name);
      });
      return { ...ft, values };
    });
    setFiltersWithValues(y.clone(fwvs));
  }, [filters, filterValues]);

  return (
    !_.isEmpty(filtersWithValues) && (
      <>
        <Row>
          {filtersWithValues.map((ft, index) => {
            return (
              <Col key={index} md={12} xl={4} xxl={3}>
                <InputGroup className="mb-3">
                  <FilterItem
                    panel={panel}
                    filter={ft}
                    values={ft.values}
                    changed={changed}
                  ></FilterItem>
                </InputGroup>
              </Col>
            );
          })}
          <Col md={12} xl={4} xxl={3}>
            <InputGroup className="mb-3">
              <LoadingButton
                variant="primary"
                className="w-50"
                loadingText={t('Loading')}
                onClick={searchClick}
              >
                {t('Search')}
              </LoadingButton>
              <Button variant="secondary" className="w-50" onClick={resetClick}>
                {t('Reset')}
              </Button>
            </InputGroup>
          </Col>
        </Row>
        <hr className="mt-0" />
      </>
    )
  );
};

FilterPanel.propTypes = {
  cacheId: PropTypes.string,
  panel: PropTypes.object,
  filters: PropTypes.array,
  values: PropTypes.object,
  search: PropTypes.func
};

export default FilterPanel;
